import React from "react";
import { sanitizeHtml } from '../../../utils/sanitizeHtml';

interface InfoProps {
  info: string;
  IconComponent: React.ElementType;
  status: string;
  isTextWithHtmlTags?: boolean;
}

const InfoTooltip: React.FC<InfoProps> = ({
  info,
  IconComponent,
  status,
  isTextWithHtmlTags = false,
}) => {
  // Replace \n with <br> if HTML tags are allowed
  const processedInfo = isTextWithHtmlTags
    ? info.replace(/\n/g, "<br>")
    : info;

  return (
    <div className="d-inline-block">
      <div className="position-relative manageInfoIcon cursor-pointer">
        <IconComponent />
        <span className={`vdabHelpText ${isTextWithHtmlTags ? "" : "text-center"}`}>
          {isTextWithHtmlTags ? (
            <span
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(processedInfo) }}
            />
          ) : (
            processedInfo
          )}
        </span>
      </div>
    </div>
  );
};

export default InfoTooltip;
